import React from 'react';
import { pick } from 'ramda';
import { useDeviceSelector } from '@core/js/store/hooks';
import { InfiniteLine } from '@core/js/components/common/InfiniteLine';
import { useComponentTranslations } from '@core/js/hooks/component';
import { WinnerItem } from './components/WinnerItem';
import { useTopWinners } from '@theme/js/components/main/TopWinners/hooks/useTopWinners';
import { MobileTable } from './components/MobileTable';

import style from './Custom.scss';

export const Custom = () => {
    const { isMobile, isPortrait } = useDeviceSelector(pick(['isMobile', 'isPortrait']));
    const translate = useComponentTranslations();
    const topWinners = useTopWinners();

    return <div className={`${style.customContainer} cms-top-winners-custom`}>
        <div className={style.head}>
            <div className={style.imageContainer}></div>
            <div className={style.title}>{translate('winnersTitle')}</div>
        </div>
        {isMobile && isPortrait
            ? <MobileTable />
            : <div className={`${style.infiniteLineContainer} cms-top-winners-infinite-line`}>
                <InfiniteLine
                    speed={50}
                    stopIfNotEnoughContent={true}
                    classNames={style}
                >
                    {topWinners.map(item => <div key={item.id} className={style.item}>
                        <WinnerItem {...item} />
                    </div>)}
                </InfiniteLine>
            </div>}
    </div>;
};
